import { collapseFadeOut } from "@core/animations";
import { apiAxiosDefaults } from "@core/api";
import { throwIfExpiredLogin } from "@core/api/helpers";
import { ExpiredLoginError } from "@core/exceptions/exceptions";
import { handleExpiredLogin } from "@core/exceptions/handlers";
import { loading } from "@core/index";
import { Controller } from "@hotwired/stimulus";
import { dispatchExpiredLoginErrorOccurred, dispatchUnexpectedErrorOccurred, } from "../../../events/erroroccurred";
import { dispatchErrorsCleared } from "../../../events/errorscleared";
import axios, { AxiosError } from "axios";
export default class default_1 extends Controller {
    // lifecycle callbacks
    initialize() {
        const axiosConfig = Object.assign({}, apiAxiosDefaults, {
            baseURL: this.baseUrlValue,
        });
        this.axios = axios.create(axiosConfig);
    }
    contentValueChanged() {
        this.contentTarget.textContent = this.contentValue;
    }
    // handlers
    edit() {
        this.setActionButtonsDisabled();
        const cancel = () => {
            this.setActionButtonsDisabled(false);
        };
        const commit = (data) => {
            this.contentValue = data.content;
            this.setActionButtonsDisabled(false);
        };
        const eventDetail = {
            item: {
                id: this.idValue,
                companyId: this.companyIdValue,
                content: this.contentValue,
            },
            commit,
            cancel,
        };
        const editEvent = {
            cancelable: true,
            detail: eventDetail,
        };
        const event = this.dispatch("edit", editEvent);
        if (event.defaultPrevented) {
            cancel();
        }
    }
    async remove({ target }) {
        if (!window.confirm("¿Desea realmente eliminar la nota? Esta acción no se puede revertir.")) {
            return;
        }
        dispatchErrorsCleared(this);
        this.setActionButtonsDisabled();
        const cancel = () => {
            this.setActionButtonsDisabled(false);
        };
        const loadingFinished = loading(target, `<span class="d-none d-lg-inline">Eliminando...</span>`);
        const eventDetail = {
            item: {
                id: this.idValue,
                companyId: this.companyIdValue,
                content: this.contentValue,
            },
        };
        const removeEvent = {
            cancelable: true,
            detail: eventDetail,
        };
        const event = this.dispatch("remove", removeEvent);
        if (event.defaultPrevented) {
            loadingFinished();
            cancel();
            return;
        }
        try {
            await this.apiDeleteItem();
        }
        catch (error) {
            if (error instanceof AxiosError) {
                if (error.response) {
                    // @todo
                }
                else if (error.request) {
                    // @todo
                }
            }
            else if (error instanceof ExpiredLoginError) {
                dispatchExpiredLoginErrorOccurred(this, error);
                handleExpiredLogin(error);
            }
            else {
                dispatchUnexpectedErrorOccurred(this, error);
            }
            cancel();
            return;
        }
        finally {
            loadingFinished();
        }
        const animation = collapseFadeOut(this.element, 350);
        animation.finished.then(() => this.element.remove());
    }
    validateUnique(event) {
        if (event.detail.id === this.idValue) {
            return;
        }
        const upperCaseContent = this.contentValue.toUpperCase();
        if (event.detail.content.toUpperCase() === upperCaseContent) {
            this.blink();
            event.preventDefault();
        }
    }
    // internals
    setActionButtonsDisabled(disabled = true) {
        this.actionButtonTargets.forEach((button) => {
            button.disabled = disabled;
        });
    }
    blink() {
        this.element.classList.remove(...this.blinkClasses);
        requestAnimationFrame(() => this.element.classList.add(...this.blinkClasses));
    }
    async apiDeleteItem() {
        const response = await this.axios.post(this.removeUrlValue, {
            companyId: this.companyIdValue,
            noteId: this.idValue,
        });
        // request is xhr on browser
        const xhr = response.request;
        // check if we got redirected to login
        const dummyA = document.createElement("a");
        dummyA.href = this.axios.getUri(response.config);
        const requestUrl = new URL(dummyA.href);
        const responseUrl = new URL(xhr.responseURL);
        throwIfExpiredLogin(requestUrl, responseUrl);
    }
}
default_1.values = {
    id: Number,
    companyId: String,
    content: String,
    baseUrl: String,
    removeUrl: String,
};
default_1.targets = ["content", "actionButton"];
default_1.classes = ["blink"];
//# sourceMappingURL=item_controller.js.map